var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { themeit } from 'react-themeit';

import AudioButtonController from '../AudioButtonController';

import baseStyle from './styles.less';
import _maxHeightTextImage from './themes/maxHeightTextImage.less';
import _maxHeightImage from './themes/maxHeightImage.less';
import _taskQuestion from './themes/taskQuestion.less';
import _taskCloze from './themes/taskCloze.less';
import _taskAnswer from './themes/taskAnswer.less';

var themeOptions = {
  base: function base(cb) {
    return cb(baseStyle);
  },
  themes: {
    maxHeightTextImage: function maxHeightTextImage(cb) {
      return cb(_maxHeightTextImage);
    },
    maxHeightImage: function maxHeightImage(cb) {
      return cb(_maxHeightImage);
    },
    taskQuestion: function taskQuestion(cb) {
      return cb(_taskQuestion);
    },
    taskCloze: function taskCloze(cb) {
      return cb(_taskCloze);
    },
    taskAnswer: function taskAnswer(cb) {
      return cb(_taskAnswer);
    }
  }
};

var Image = function (_Component) {
  _inherits(Image, _Component);

  function Image(props) {
    _classCallCheck(this, Image);

    var _this = _possibleConstructorReturn(this, (Image.__proto__ || Object.getPrototypeOf(Image)).call(this, props));

    _this.getImageOrientation = function (e) {
      var ratio = e.target.naturalWidth / e.target.naturalHeight;
      _this.setState({
        orientation: ratio > 1 ? 'landscape' : 'portrait'
      });
    };

    _this.expandImage = function (e) {
      e.stopPropagation();
      var toggleHideOverflow = _this.props.toggleHideOverflow;
      var expandImage = _this.state.expandImage;

      toggleHideOverflow();
      _this.setState({
        expandImage: !expandImage
      });
    };

    _this.state = {
      orientation: 'landscape',
      expandImage: false
    };
    return _this;
  }

  _createClass(Image, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          styles = _props.styles,
          id = _props.id,
          imageSource = _props.imageSource,
          audioSource = _props.audioSource,
          expand = _props.expand,
          clicked = _props.clicked;
      var _state = this.state,
          orientation = _state.orientation,
          expandImage = _state.expandImage;

      return React.createElement(
        'div',
        {
          role: 'button',
          className: styles.container + ' ' + (orientation === 'landscape' ? styles.landscape : styles.portrait) + ' ' + (clicked && styles.clicked) + ' ' + (expandImage && styles.imageExpandContainer),
          onClick: expandImage ? function (e) {
            e.stopPropagation();
          } : null // disable click event
        },
        React.createElement('img', {
          src: imageSource,
          className: styles.image + ' ' + (expandImage && styles.imageExpand),
          alt: imageSource,
          onLoad: this.getImageOrientation
        }),
        expand && React.createElement('div', {
          role: 'button',
          className: '' + (expandImage ? styles.contract + ' icon-contract' : styles.expand + ' icon-expand'),
          onClick: this.expandImage,
          tabIndex: '0'
        }),
        audioSource && !expandImage && React.createElement(AudioButtonController, { id: id, className: styles.audioButton, audioSource: audioSource })
      );
    }
  }]);

  return Image;
}(Component);

Image.propTypes = process.env.NODE_ENV !== "production" ? {
  styles: PropTypes.objectOf(PropTypes.string),
  id: PropTypes.number,
  imageSource: PropTypes.string.isRequired,
  audioSource: PropTypes.string,
  expand: PropTypes.bool,
  clicked: PropTypes.bool,
  toggleHideOverflow: PropTypes.func
} : {};

Image.defaultProps = {
  styles: null,
  id: -1,
  audioSource: null,
  expand: false,
  clicked: false,
  toggleHideOverflow: function toggleHideOverflow() {}
};

export default themeit(themeOptions)(Image);